import { CSSObject } from '@emotion/react';

export const getCallAgentPlusClientsStyle = (): CSSObject => ({
    textAlign: 'start',
});
